import { useGetSchedulerVersions } from '@automata/wfb-api';
import { useMemo } from 'react';

import { sortVersionsDescending } from '../../utils/sortVersions';

export const useSchedulerVersions = () => {
  const {
    data: schedulerVersionsData,
    isLoading,
    error,
  } = useGetSchedulerVersions({});

  const availableVersions = useMemo(
    () =>
      schedulerVersionsData
        ? sortVersionsDescending(schedulerVersionsData['maestro'] || [])
        : [],
    [schedulerVersionsData]
  );

  const latestVersion = availableVersions[0] || null;

  return {
    availableVersions,
    latestVersion,
    isLoading,
    error,
  };
};
